import { render, staticRenderFns } from "./CreateEditBackup.vue?vue&type=template&id=742970c5&scoped=true&"
import script from "./CreateEditBackup.vue?vue&type=script&lang=js&"
export * from "./CreateEditBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742970c5",
  null
  
)

export default component.exports